import axios, { InternalAxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios';
//导入配置文件
import { dev } from '@/config/dev.env';
import { prod } from '@/config/prod.env';
import qs from 'qs';
//当前运行环境
const NODE_ENV = process.env.NODE_ENV;

const getParse = (str: string, key: string) => {
  const parse = qs.parse(str, { ignoreQueryPrefix: true });
  // eslint-disable-next-line no-prototype-builtins
  if (parse instanceof Object && parse.hasOwnProperty(key)) {
    return parse[key];
  }
  return '';
};

const token =
  getParse(location.search, 'token') ||
  sessionStorage.getItem('Token') ||
  (window.top && getParse(window.top.location.search, 'token'));

console.log(token);

const xsrfHeaderName = 'token';
axios.defaults.xsrfHeaderName = xsrfHeaderName;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: NODE_ENV === 'production' ? prod.BASE_API : dev.BASE_API,
  // timeout: 50000,
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (token) {
      config.headers.token = `${token}`;
    }
    // 在发送请求之前做些什么
    return config;
  },
  (error: any) => {
    // 处理请求错误
    return Promise.reject(error);
  },
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // 对响应数据做点什么
    return response;
  },
  (error: any) => {
    // 处理响应错误
    return Promise.reject(error);
  },
);

export default axiosInstance;
